import { render, staticRenderFns } from "./NoticeBox.vue?vue&type=template&id=bb2be902&scoped=true"
import script from "./NoticeBox.vue?vue&type=script&lang=js"
export * from "./NoticeBox.vue?vue&type=script&lang=js"
import style0 from "./NoticeBox.vue?vue&type=style&index=0&id=bb2be902&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2be902",
  null
  
)

export default component.exports